export const articlesData = [
    {
        id: 1,
        src: `https://s3.amazonaws.com/img.mynetdiary.com/blog/food-score-new.jpeg`,
        title: "What is MyNetDiary's Food Grade and why is it important?",
        desc: "The Food Grade is a simple MyNetDiary tool to help you compare similar foods to find the healthiest choice. Instead of reading and comparing the nutrition facts panels of several foods, Food Grade provides each food with a letter.",
        link:"."
    },
    {
        id: 2,
        src: 'https://s3.amazonaws.com/img.mynetdiary.com/blog/support-to-lose-weight.jpeg',
        title: "How to get positive support to lose weight and keep it off!",
        desc: "Developing a support system to lose weight, maintain weight, and for a healthy lifestyle cannot be overstated. Read on for ideas to create a support system for weight loss that works for you.",
        link:"."
    },
    {
        id: 3,
        src: 'https://s3.amazonaws.com/img.mynetdiary.com/blog/benefits-of-eating-pumpkin-1.jpeg',
        title: "Not just for decoration: Enjoy the health benefits of eating pumpkin",
        desc: "The benefits of eating pumpkin go far beyond the satisfaction of creamy pumpkin pie. Packed with vitamins and minerals, a half cup of pumpkin contains only 22 calories! Whether you use fresh or canned, fall is the perfect season for cook...",
        link:"."
    },
    {
        id: 4,
        src: 'https://s3.amazonaws.com/img.mynetdiary.com/blog/being-tired-and-losing-weight.jpeg',
        title: "Losing weight might result in being tired, so try these solutions",
        desc: "Does being tired and working on losing weight seem to coincide for you? Here are some tips to help you figure out what might be happening.",
        link:"."
    }
]